export enum EWorkshopHostedState {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}
